var map = {
	"./7640fcc8f0cc3f559bf01152805ab018 copy.png": 737,
	"./EXCHANGE-PAGE-SERVICES.png": 738,
	"./GMetFCNToY.png": 739,
	"./Heart copy 6.png": 740,
	"./HrfhVNmTG9.png": 741,
	"./avtar3.png": 219,
	"./back-grey.png": 742,
	"./background-benefit.png": 743,
	"./background-image-testimonial-down.png": 744,
	"./background-image-testimonial-mess.png": 745,
	"./background-image-testimonial-up.png": 746,
	"./banner-bg.png": 341,
	"./banner-img.png": 747,
	"./big-image-left.png": 748,
	"./butterfly-soul_59145-4.png": 749,
	"./category/background-loadmore.png": 750,
	"./category/banner-back.png": 751,
	"./category/banner-four.png": 752,
	"./category/banner-one.png": 753,
	"./category/banner-three.png": 754,
	"./category/banner-two.png": 755,
	"./category/checktick.png": 62,
	"./category/collection-1.png": 756,
	"./category/collection-2.png": 757,
	"./category/collection-3.png": 758,
	"./category/collection-4.png": 759,
	"./category/domain.png": 760,
	"./category/dot-nft.png": 63,
	"./category/down-cat.png": 93,
	"./category/etherum.png": 351,
	"./category/expend-2.png": 169,
	"./category/expend.png": 170,
	"./category/fire.png": 352,
	"./category/girl-2nd.png": 761,
	"./category/girl-3rd.png": 762,
	"./category/girl.png": 94,
	"./category/hotbid-four.png": 763,
	"./category/hotbid-one.png": 764,
	"./category/hotbid-three.png": 765,
	"./category/hotbid-two.png": 766,
	"./category/klaytn.png": 221,
	"./category/likeHeart.png": 73,
	"./category/menn.png": 74,
	"./category/mercedes.png": 75,
	"./category/music.png": 767,
	"./category/paint.png": 768,
	"./category/photo.png": 769,
	"./category/polygen.png": 222,
	"./category/target.png": 770,
	"./category/top-cat.png": 771,
	"./category/unlikeHeart.png": 353,
	"./category/volly.png": 772,
	"./client-people-four.png": 773,
	"./client-people-one.png": 774,
	"./client-people-three.png": 775,
	"./client-people-two.png": 776,
	"./client-test-left.png": 777,
	"./contact-bg.png": 354,
	"./footer-bg.png": 778,
	"./heart.png": 779,
	"./images-people.png": 780,
	"./left-arrow.png": 781,
	"./let-talk-right-side.png": 782,
	"./lets-talk-heart.png": 783,
	"./logo-edit.png": 784,
	"./logo.png": 335,
	"./logofaq.png": 785,
	"./loogo-header.png": 786,
	"./lwAAHO1kd9.png": 787,
	"./nft-market-place.png": 344,
	"./our-benefit-five.png": 347,
	"./our-benefit-four.png": 349,
	"./our-benefit-one.png": 345,
	"./our-benefit-six.png": 350,
	"./our-benefit-three.png": 346,
	"./our-benefit-two.png": 348,
	"./our-benefits.png": 788,
	"./our-left-benefit.png": 789,
	"./our-menefit-left-boxes.png": 790,
	"./pick-bg.png": 343,
	"./pick-by-design-left.png": 791,
	"./pick-by-design-main-back.png": 792,
	"./pick-by-design-right.png": 793,
	"./pick-by-design.png": 794,
	"./profile/166256.png": 795,
	"./profile/avatar2.jpg": 796,
	"./profile/avataricon.png": 797,
	"./profile/avtar3.png": 223,
	"./profile/banner-back.png": 798,
	"./profile/banner-back1.png": 224,
	"./profile/banner-previw.png": 355,
	"./profile/check-step-ok.png": 799,
	"./profile/check-step.png": 800,
	"./profile/checktick.png": 801,
	"./profile/discord-form.png": 356,
	"./profile/eth-1.png": 802,
	"./profile/eth-2.png": 357,
	"./profile/eth.png": 336,
	"./profile/export.png": 803,
	"./profile/global.png": 804,
	"./profile/instagram-form.png": 225,
	"./profile/loding.png": 805,
	"./profile/logo-mid.png": 806,
	"./profile/logout.png": 807,
	"./profile/meduim-form.png": 358,
	"./profile/preview-for.png": 359,
	"./profile/profile-bg.png": 148,
	"./profile/save-form.png": 360,
	"./profile/settings-icon.png": 226,
	"./profile/share-icon.png": 227,
	"./profile/telegram-from.png": 361,
	"./profile/three-dot.png": 808,
	"./profile/tooltip.png": 809,
	"./profile/twitter-form.png": 362,
	"./profile/visa-card.png": 810,
	"./profile/wallet-form.png": 363,
	"./profile/web-form.png": 228,
	"./recent-before.png": 811,
	"./recent-bg.png": 364,
	"./recent-one.png": 812,
	"./recent-three.png": 813,
	"./recent-two.png": 814,
	"./right-arrow.png": 815,
	"./side-layer-benefit.png": 816,
	"./slider3.png": 817,
	"./softtik-logo.png": 818,
	"./testimonial-main-back.png": 819,
	"./top-area-img.png": 342,
	"./top-trending.png": 820,
	"./tranding-bg.png": 821,
	"./user-avatar.png": 218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 168;